function init(){
  console.log("initialized");
  const customMetafieldBadges = document.querySelectorAll('.custom-metafield-badge');
  const badges = document.querySelectorAll('.badge');
  customMetafieldBadges.forEach((el)=>{
    if(el.classList.contains('pre-selected-variant')){
      el.classList.remove('visible');
    }
    else{
       el.classList.add('visible');
    }
  })
}

init();

class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll('.variant_swatch');
    this.swatchClick = this.handleSwatchClick.bind(this);
    this.showStrikeThroughPrice = this.dataset.showStrikethroughPrice;
    // Mirrors the `show_collection_discounts` theme setting so the A/B off-state also suppresses
    // discount UI that this script would otherwise add after a colour is picked.
    this.showDiscounts = this.dataset.showDiscounts;
  }

  connectedCallback() {
    const swatchWrapper = this;
    const list = swatchWrapper.swatches;

    for (const key in list) {
      if (Object.hasOwnProperty.call(list, key)) {
        const element = list[key];
        element.addEventListener('click', this.swatchClick);
      }
    }
  }

  disconnectedCallback() {
    const swatchWrapper = this;
    const list = swatchWrapper.swatches;
    for (const key in list) {
      if (Object.hasOwnProperty.call(list, key)) {
        const element = list[key];
        element.removeEventListener('click', this.swatchClick);
      }
    }
  }

  handleSwatchClick(e) {
    e.preventDefault();
    const checkedRadio = this.checkSelected(e);
    this.updateCardImage(checkedRadio);
    this.updateLinkUrl(checkedRadio);
    // The featured-colour auto-select in theme.liquid fires a synthetic click on load purely to swap
    // the card image. It must NOT collapse the server-rendered price range to a single variant's
    // price or force the Sale badge on - that produced "$34" sitting beside an "Up to 44% off" badge
    // computed from the full $26-$47 range. Price/badges only move once a shopper picks a colour.
    if (window.saaltFeaturedColorAutoSelect) return;
    this.updatePrice(checkedRadio);
    this.updatePercentOff(checkedRadio);
    this.toggleSaleBadge(checkedRadio);
  }

  // Cents come from data attributes rendered in card-product.liquid rather than being parsed back
  // out of money-formatted strings: "$1,234"-style formatting and multi-currency make string parsing
  // unreliable, and the previous string comparison (price < compareAtPrice) compared "$9" against
  // "$47" lexicographically - wrong for any single-digit price.
  static centsOf(radio, key) {
    const raw = radio && radio.dataset ? radio.dataset[key] : '';
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : null;
  }

  static isOnSale(radio) {
    const price = ProductCardSwatches.centsOf(radio, 'variantPriceCents');
    const compare = ProductCardSwatches.centsOf(radio, 'variantCompareCents');
    return price !== null && compare !== null && compare > price;
  }

  // Server-side the badge reads "Up to X% off", because with no colour chosen the card shows a price
  // RANGE and X is the best discount across all variants. Once a specific colour is chosen that
  // wording is wrong twice over: a non-discounted colour should show no badge at all, and a
  // discounted colour should show its own exact percentage, not the range's maximum.
  updatePercentOff(checkedRadio) {
    const priceEl = checkedRadio.closest('.card__content')?.querySelector('.price');
    if (!priceEl) return;
    let badge = priceEl.querySelector('.percent-off');

    if (this.showDiscounts === 'false' || !ProductCardSwatches.isOnSale(checkedRadio)) {
      if (badge) badge.hidden = true;
      return;
    }

    const price = ProductCardSwatches.centsOf(checkedRadio, 'variantPriceCents');
    const compare = ProductCardSwatches.centsOf(checkedRadio, 'variantCompareCents');
    const percent = Math.round(((compare - price) / compare) * 100);

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'percent-off';
      priceEl.appendChild(badge);
    }
    badge.hidden = false;
    badge.textContent = `${percent}% off`;
  }

 checkSelected(e) {
    // Find the closest product-card-swatches element
    const swatchesElement = e.target.closest('product-card-swatches');
    if (!swatchesElement) {
        return null;
    }

    // Get the currently selected input
    const currentlySelected = swatchesElement.querySelector('input[name="colorSwatch"]:checked');
    if (currentlySelected) {
        currentlySelected.checked = false;
    }

    // Check the previous sibling input if it exists and is an input element
    if (e.target.previousSibling && e.target.previousSibling.tagName === 'INPUT') {
        e.target.previousSibling.checked = true;
    }

    // Return the newly selected input
    return swatchesElement.querySelector('input[name="colorSwatch"]:checked');
}

  updateCardImage(checkedRadio) {
    const imgUrl = checkedRadio.dataset.imageUrl;
    const cardImg = checkedRadio
      .closest('.card-wrapper.product-card-wrapper')
      .querySelector('.media')
      .querySelector('img');
    cardImg.src = imgUrl;
    cardImg.srcset = this.createNewSrcsetVals(cardImg.srcset, imgUrl);
  }

  createNewSrcsetVals(srcset, replacement) {
    const splitSrcset = srcset.split(',');
    const cleanedUrl = replacement.replace(new RegExp(/(?:_)?\d+x/, 'g'), '');
    let srcsetString = '';
    for (const url of splitSrcset) {
      const size = url.split('&width=')[1];
      size ? (srcsetString += `${cleanedUrl}&width=${size}, `) : null;
    }
    srcsetString = srcsetString.slice(0, -2);
    return srcsetString;
  }

  updateLinkUrl(checkedRadio) {
    const cardLinks = checkedRadio.closest('.card-wrapper.product-card-wrapper').querySelectorAll('a');
    for (const linkEl of cardLinks) {
      linkEl.href = checkedRadio.dataset.variantUrl;
    }
  }

  updatePrice(checkedRadio) {
    const closestCardEl = checkedRadio.closest('.card__content');
    const priceEl = closestCardEl
      .querySelector('.card__information')
      .querySelector('.card-information')
      .querySelector('.price');
    const closestPriceContainer = closestCardEl.querySelector('.price__container');
    const salePriceContainer = closestPriceContainer.querySelector('.price__sale');
    const regPriceContainer = closestPriceContainer.querySelector('.price__regular');
    const compareAtPrice = checkedRadio.dataset.variantCompareAtPrice;
    const regPrice = checkedRadio.dataset.variantPrice;

    // Null-safe writer: with the A/B switch off, price.liquid suppresses the
    // `<s class="price-item price-item--regular">` strikethrough entirely, so that lookup returns
    // null. Assigning .textContent on null throws, which would abort handleSwatchClick() before
    // updatePercentOff() and toggleSaleBadge() run - leaving stale badges on the card.
    const setText = (root, selector, value) => {
      const node = root ? root.querySelector(selector) : null;
      if (node) node.textContent = value;
    };

    // `showDiscounts === 'false'` (the A/B off-state) must fall through to the else branch: the
    // shopper still pays the sale price, but the card shows it plainly with no "was" strikethrough.
    if (
      this.showDiscounts !== 'false' &&
      this.showStrikeThroughPrice === 'true' &&
      compareAtPrice &&
      regPrice !== compareAtPrice
    ) {
      priceEl.classList.add('price--on-sale');
      setText(salePriceContainer, '.price-item.price-item--sale', regPrice);
      setText(salePriceContainer, '.price-item.price-item--regular', compareAtPrice);
      setText(regPriceContainer, '.price-item.price-item--regular', regPrice);
    } else {
      priceEl.classList.remove('price--on-sale');
      setText(regPriceContainer, '.price-item.price-item--regular', regPrice);
      setText(salePriceContainer, '.price-item.price-item--regular', regPrice);
    }
  }

  toggleSaleBadge(checkedRadio) {
    const badgeEls = checkedRadio.closest('.card').querySelectorAll('.badge');
    // Cents comparison, not the old lexicographic string compare of formatted money values.
    // Suppressed entirely when discounts are switched off for the A/B test.
    if (this.showDiscounts !== 'false' && ProductCardSwatches.isOnSale(checkedRadio)) {
      for (const badgeEl of badgeEls) {
        if(badgeEl.classList.contains('custom-metafield-badge')){
          console.log(badgeEl,"badgellll...");
          console.log("yes it is..");
           badgeEl.classList.remove('visible');
        }
        else{
           badgeEl.classList.add('visible');
        }
        
      }
    } else {
      for (const badgeEl of badgeEls) {
        if(badgeEl.classList.contains('custom-metafield-badge')){
           console.log(badgeEl,"badgellll new...")
           badgeEl.classList.add('visible');
        }
        else{
           badgeEl.classList.remove('visible');
        }
      }
    }
  }
}

customElements.define('product-card-swatches', ProductCardSwatches);
